import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'

import { NavigationOpenables } from 'shared/types/navigation'

const defaultNavigationOpenablesState = {
  [NavigationOpenables.cart]: false,
  [NavigationOpenables.postalCode]: false,
  [NavigationOpenables.deliveryReservation]: false,
  [NavigationOpenables.deliveryReservationNoUser]: false,
  [NavigationOpenables.searchDropdown]: false
}

export const useNavigation = () => {
  const pathname = usePathname()
  const [openablesState, setOpenablesState] = useState(
    defaultNavigationOpenablesState
  )

  const handleOpenablesStateToggle = (
    name: NavigationOpenables,
    value: boolean
  ) => {
    switch (name) {
      case NavigationOpenables.cart:
        if (value) {
          setOpenablesState({
            cart: value,
            postalCode: false,
            deliveryReservation: false,
            deliveryReservationNoUser: false,
            searchDropdown: false
          })
        } else {
          setOpenablesState(prev => ({ ...prev, cart: value }))
        }
        break
      case NavigationOpenables.postalCode:
        if (value) {
          setOpenablesState({
            cart: false,
            postalCode: value,
            deliveryReservation: false,
            deliveryReservationNoUser: false,
            searchDropdown: false
          })
        } else {
          setOpenablesState(prev => ({ ...prev, postalCode: value }))
        }
        break
      case NavigationOpenables.deliveryReservation:
        if (value) {
          setOpenablesState({
            cart: false,
            postalCode: false,
            deliveryReservation: value,
            deliveryReservationNoUser: false,
            searchDropdown: false
          })
        } else {
          setOpenablesState(prev => ({ ...prev, deliveryReservation: value }))
        }
        break
      case NavigationOpenables.deliveryReservationNoUser:
        if (value) {
          setOpenablesState({
            cart: false,
            postalCode: false,
            deliveryReservation: false,
            deliveryReservationNoUser: value,
            searchDropdown: false
          })
        } else {
          setOpenablesState(prev => ({
            ...prev,
            deliveryReservationNoUser: value
          }))
        }
        break
      case NavigationOpenables.searchDropdown:
        if (value) {
          setOpenablesState({
            cart: false,
            postalCode: false,
            deliveryReservation: false,
            deliveryReservationNoUser: false,
            searchDropdown: value
          })
        } else {
          setOpenablesState(prev => ({ ...prev, searchDropdown: value }))
        }
        break
      default:
        break
    }
  }

  useEffect(() => {
    setOpenablesState(defaultNavigationOpenablesState)
  }, [pathname])

  return {
    openablesState,
    handleOpenablesStateToggle
  }
}
